<template>
  <div class="articles-for-category">
    <div class="last-articles">
      <div class="line">
        <div>{{ getCategory(categoryColumn(), $route.params.categoryValue).name }}</div>
      </div>
      <div class="row">
        <articles-query :category="{ name: categoryColumn(), value: $route.params.categoryValue }">
          <template slot-scope="props">
            <div v-for="article in props.articles">
              <article-preview :article="article"></article-preview>
            </div>
          </template>
        </articles-query>
      </div>
    </div>
  </div>
</template>

<script>
  import { ArticlesQuery, categories } from 'itrnews-vuejs-api';
  import ArticlePreview from './elements/ArticlePreview';

  export default {
    name: 'ArticlesForCategory',
    components: { ArticlesQuery, ArticlePreview },
    mixins: [categories],
    methods: {
      categoryColumn() {
        if (this.$router.currentRoute.name === 'ArticlesForLVNCategory') {
          return 'lvn_oid';
        }

        return 'lvn_topic_oid';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ArticlesForCategory.vue